/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { CompanyProblemType } from "./CompanyProblemType";
import {
  CompanyProblemTypeFromJSON,
  CompanyProblemTypeFromJSONTyped,
  CompanyProblemTypeToJSON,
  CompanyProblemTypeToJSONTyped,
} from "./CompanyProblemType";

/**
 *
 * @export
 * @interface CompanyProblems
 */
export interface CompanyProblems {
  /**
   *
   * @type {string}
   * @memberof CompanyProblems
   */
  problemId?: string;
  /**
   *
   * @type {string}
   * @memberof CompanyProblems
   */
  companyId?: string;
  /**
   *
   * @type {CompanyProblemType}
   * @memberof CompanyProblems
   */
  problemType?: CompanyProblemType;
  /**
   *
   * @type {string}
   * @memberof CompanyProblems
   */
  details?: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CompanyProblems
   */
  createdAt?: OffsetDateTime;
}

/**
 * Check if a given object implements the CompanyProblems interface.
 */
export function instanceOfCompanyProblems(
  value: object,
): value is CompanyProblems {
  return true;
}

export function CompanyProblemsFromJSON(json: any): CompanyProblems {
  return CompanyProblemsFromJSONTyped(json, false);
}

export function CompanyProblemsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CompanyProblems {
  if (json == null) {
    return json;
  }
  return {
    problemId: json["problemId"] == null ? undefined : json["problemId"],
    companyId: json["companyId"] == null ? undefined : json["companyId"],
    problemType:
      json["problemType"] == null
        ? undefined
        : CompanyProblemTypeFromJSON(json["problemType"]),
    details: json["details"] == null ? undefined : json["details"],
    createdAt: json["createdAt"] == null ? undefined : json["createdAt"],
  };
}

export function CompanyProblemsToJSON(json: any): CompanyProblems {
  return CompanyProblemsToJSONTyped(json, false);
}

export function CompanyProblemsToJSONTyped(
  value?: CompanyProblems | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    problemId: value["problemId"],
    companyId: value["companyId"],
    problemType: CompanyProblemTypeToJSON(value["problemType"]),
    details: value["details"],
    createdAt: value["createdAt"],
  };
}
